import React, { useEffect, useState } from 'react';
import { TextField, Box, Typography, InputAdornment } from '@mui/material';

interface RangeFieldProps {
    minimumValue?: string | null;
    maximumValue?: string | null;
    onValuesChange: (minValue: string, maxValue: string) => void;
    onChange?: (value: { min: number; max: number }) => void;
}

const RangeField: React.FC<RangeFieldProps> = ({
    minimumValue,
    maximumValue,
    onValuesChange,
}) => {
    const [minValue, setMinValue] = useState(minimumValue || "");
    const [maxValue, setMaxValue] = useState(maximumValue || "");
    const [focusedField, setFocusedField] = useState<"min" | "max" | null>(null);

    useEffect(() => {
        setMinValue(minimumValue || "");
    }, [minimumValue]);
    
    useEffect(() => {
        setMaxValue(maximumValue || "");
    }, [maximumValue]);

    const handleMinChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newMinValue = event.target.value;
        setMinValue(newMinValue);
        onValuesChange(newMinValue, maxValue);
    };

    const handleMaxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newMaxValue = event.target.value;
        setMaxValue(newMaxValue);
        onValuesChange(minValue, newMaxValue);
    };

    const handleFocus = (field: "min" | "max") => {
        setFocusedField(field);
    };

    const handleBlur = () => {
        setFocusedField(null);
    };

    const isActive = minValue !== '' || maxValue !== '';

    return (
        <Box display="flex" flexDirection="row" alignItems="center" gap={2}>
            <TextField
                variant="outlined"
                placeholder="00"
                size="small"
                value={minValue}
                onChange={handleMinChange}
                onFocus={() => handleFocus("min")}
                onBlur={handleBlur}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start" sx={{
                            backgroundColor: '#f4f4f4',
                            '& .MuiOutlinedInput-root': {
                                height: '35px',
                                border: 'none',
                                '& fieldset': {
                                    borderColor: 'transparent',
                                },
                                '&.Mui-focused fieldset': {
                                    borderColor: '#6455ED',
                                    borderWidth: '1px',
                                },
                                '&:hover fieldset': {
                                    borderColor: '#6455ED',
                                },
                                '&:hover': {
                                    backgroundColor: focusedField === "min" || isActive ? '#ffffff' : '#f4f4f4',
                                },
                            },
                        }}>
                            <Typography sx={{ color: '#666', fontWeight: 600 }}>₹</Typography>
                        </InputAdornment>
                    ),
                }}
                inputProps={{
                    style: {
                        marginLeft: "0.3rem",
                        height: '35px',
                        padding: '0',
                        lineHeight: '35px',
                    },
                }}
                sx={{
                    borderRadius: "0.15rem",
                    backgroundColor: '#f4f4f4',
                    '& .MuiOutlinedInput-root': {
                        height: '35px',
                        border: 'none',
                        '& fieldset': {
                            borderColor: 'transparent',
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: '#6455ED',
                            borderWidth: '1px',
                        },
                        '&:hover fieldset': {
                            borderColor: '#6455ED',
                        },
                        '&:hover': {
                            backgroundColor: focusedField === "min" || isActive ? '#ffffff' : '#f4f4f4',
                        },
                    },
                }}
            />
            <Typography variant="body1" color="#6F6F6F" sx={{ fontWeight: "bold", marginTop: "0px" }}>
                -
            </Typography>
            <TextField
                variant="outlined"
                placeholder="00"
                size="small"
                value={maxValue}
                onChange={handleMaxChange}
                onFocus={() => handleFocus("max")}
                onBlur={handleBlur}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start"
                            sx={{
                                backgroundColor: '#f4f4f4',
                                '& .MuiOutlinedInput-root': {
                                    height: '35px',
                                    border: 'none',
                                    '& fieldset': {
                                        borderColor: 'transparent',
                                    },
                                    '&.Mui-focused fieldset': {
                                        borderColor: '#6455ED',
                                        borderWidth: '1px',
                                    },
                                    '&:hover fieldset': {
                                        borderColor: '#6455ED',
                                    },
                                    '&:hover': {
                                        backgroundColor: focusedField === "max" || isActive ? '#ffffff' : '#f4f4f4',
                                    },
                                },
                            }}>
                            <Typography sx={{ color: '#666', fontWeight: 600 }}>₹</Typography>
                        </InputAdornment>
                    ),
                }}
                inputProps={{
                    style: {
                        marginLeft: "0.3rem",
                        height: '35px',
                        padding: '0',
                        lineHeight: '35px',
                    },
                }}
                sx={{
                    borderRadius: "0.15rem",
                    backgroundColor: '#f4f4f4',
                    '& .MuiOutlinedInput-root': {
                        height: '35px',
                        border: 'none',
                        '& fieldset': {
                            borderColor: 'transparent',
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: '#6455ED',
                            borderWidth: '1px',
                        },
                        '&:hover fieldset': {
                            borderColor: '#6455ED',
                        },
                        '&:hover': {
                            backgroundColor: focusedField === "max" || isActive ? '#ffffff' : '#f4f4f4',
                        },
                    },
                }}
            />
        </Box>
    );
};

export default RangeField;
